import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "_flexcol _col-span-4 _gap-1" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_skeleton_line = _resolveComponent("skeleton-line")
  const _component_skeleton_wrapper = _resolveComponent("skeleton-wrapper")

  return (_openBlock(), _createBlock(_component_skeleton_wrapper, { class: "_grid _grid-cols-5 _gap-2 _jc-st _px-2 _py-3" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_skeleton_line, { height: 22 }),
        _createVNode(_component_skeleton_line, { height: 18 })
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_skeleton_line, { height: 22 })
      ])
    ]),
    _: 1 /* STABLE */
  }))
}